'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var constants = require('./constants.js');
var languageFromLocale = require('./utilities/languageFromLocale.js');

function hasFamilyNameGivenNameOrdering(locale) {
  const familyNameGivenNameOrdering = constants.FAMILY_NAME_GIVEN_NAME_ORDERING_INDEXED_BY_LANGUAGE.get(languageFromLocale.languageFromLocale(locale));
  return Boolean(familyNameGivenNameOrdering);
}

exports.hasFamilyNameGivenNameOrdering = hasFamilyNameGivenNameOrdering;
